/* SIX PACK v9 — menú móvil, acceso directo a preguntas y precios animados */
(function () {
  "use strict";
  var root = document.documentElement;

  /* Menú móvil: bloquea el scroll de fondo mientras está abierto */
  var mb = document.getElementById("menuBtn");
  if (mb && "MutationObserver" in window) {
    var sync = function () { root.classList.toggle("mn9-open", mb.getAttribute("aria-expanded") === "true"); };
    new MutationObserver(sync).observe(mb, { attributes: true, attributeFilter: ["aria-expanded"] });
  }

  /* Rendimiento: la barra 2D de respaldo solo se dibuja si no hay 3D, nunca durante la intro,
     y solo cuando cambia el scroll (antes se redibujaba en cada cuadro y bloqueaba equipos sin GPU) */
  if (window.SPBarbell) {
    var BP = window.SPBarbell.prototype, draw0 = BP.draw, lastP = -1;
    BP.draw = function (p, t) {
      if (window.SP3D || root.classList.contains("intro-on")) return;
      if (Math.abs(p - lastP) < 0.002) return;
      lastP = p;
      return draw0.call(this, p, t);
    };
  }

  /* Preguntas: un toque abre la respuesta exacta */
  function openFaq(id, smooth) {
    var d = document.getElementById(id);
    if (!d || d.tagName !== "DETAILS") return false;
    d.open = true;
    var y = d.getBoundingClientRect().top + window.pageYOffset - 110;
    window.scrollTo({ top: y, behavior: smooth ? "smooth" : "auto" });
    d.classList.remove("hl9"); void d.offsetWidth; d.classList.add("hl9");
    return true;
  }
  document.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#faq-"]');
    if (!a) return;
    if (openFaq(a.getAttribute("href").slice(1), true)) {
      e.preventDefault();
      try { history.replaceState(null, "", a.getAttribute("href")); } catch (x) {}
    }
  });
  if (/^#faq-\d+$/.test(location.hash)) window.addEventListener("load", function () { setTimeout(function () { openFaq(location.hash.slice(1), false); }, 300); });

  /* Precios: cuentan hasta su valor al entrar en pantalla */
  var nums = [].slice.call(document.querySelectorAll(".pr9 b[data-to]"));
  if (nums.length && "IntersectionObserver" in window) {
    var EN = (root.lang || "es").slice(0, 2) === "en";
    var nf = new Intl.NumberFormat(EN ? "en-US" : "es-CO", { maximumFractionDigits: 0 });
    var run = function (el) {
      var to = +el.getAttribute("data-to"), t0 = performance.now(), dur = 1700;
      el.style.minWidth = el.offsetWidth + "px";
      (function step(now) {
        var k = Math.min((now - t0) / dur, 1), e = k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
        el.textContent = nf.format(Math.round(to * e / 1000) * 1000);
        if (k < 1) requestAnimationFrame(step);
      })(t0);
    };
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { io.unobserve(en.target); run(en.target); } });
    }, { threshold: 0.6 });
    nums.forEach(function (n) { io.observe(n); });
  }
})();
